import { Component, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploaderComponent),
      multi: true
    }
  ],
})

export class FileUploaderComponent implements ControlValueAccessor {

  /*
    The accept takes as its value a string containing one or more of these unique file type specifiers, separated by commas.
    For example: "image/*,.pdf"
  */
  @Input() accept: string;
  /*
    When the multiple is true, the file input allows the user to select more than one file.
  */
  @Input() multiple: boolean;
  /*
    The fileSizeLimit takes the value in kilo bytes and set the maximum allowed document size for individual files.
  */
  @Input() fileSizeLimit = 512;

  allFiles: FileList;
  isDisabled: boolean;
  fileInput: HTMLInputElement;
  showFiles = false;
  imageFileSrc: any;
  pdfFileSrc: any;
  carouselActiveFile: number;

  private _onChange: any = () => { };
  private _onTouched: any = () => { };

  constructor(private element: ElementRef<HTMLInputElement>, private sanitization: DomSanitizer) { }

  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList): void {
    this._onTouched();
    let fileList = event;
    this.allFiles = null;
    if (this.isMaxFileSizeExceeded(fileList)) {
      fileList = null;
    }
    this._onChange(fileList);
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  writeValue(value: null): void {
    this.fileInput = this.element.nativeElement.querySelector('#file-input');
    if (this.fileInput) {
      this.fileInput.value = '';
    }
    this.allFiles = null;
  }


  isMaxFileSizeExceeded(fileList: FileList): boolean {
    const keys = Object.keys(fileList);
    let maxSizeLimitExceeded = false;
    // this.allFiles = [];
    this.allFiles = fileList;
    keys.forEach(key => {
      // this.allFiles.push(fileList[key]);
      const fileSize: number = Number((fileList[key].size / 1024).toFixed(4));
      if (fileSize > this.fileSizeLimit) {
        maxSizeLimitExceeded = true;
      }
    });
    if (maxSizeLimitExceeded) {
      alert('Maximum document size limit 512kb exceeded!');
      this.fileInput = this.element.nativeElement.querySelector('#file-input');
      if (this.fileInput)
        this.fileInput.value = '';
      // this.file = null;
      this.allFiles = null;
    }
    return maxSizeLimitExceeded;
  }

  deleteFile(): void {
    this.allFiles = null;
    this._onChange(this.allFiles);
    this.pdfFileSrc = null;
    this.imageFileSrc = null;
  }

  viewFile(index: number): void {
    this.carouselActiveFile = index;
    if (this.allFiles[index].type === 'application/pdf') {
      let url: any = URL.createObjectURL(this.allFiles[index]);
      window.open(url, '_blank');
      url = this.sanitization.bypassSecurityTrustResourceUrl(url);
      this.pdfFileSrc = url;
    }
    else if (this.allFiles[index].type.includes('image/')) {
      this.imageFileSrc = URL.createObjectURL(this.allFiles[index]);
      this.imageFileSrc = this.sanitization.bypassSecurityTrustUrl(this.imageFileSrc);
    }
    // window.open(`blob:${this.fileSrc}`);
  }

  closeFileView(): void {
    URL.revokeObjectURL(this.imageFileSrc);
    URL.revokeObjectURL(this.pdfFileSrc);
    this.pdfFileSrc = undefined;
    this.imageFileSrc = undefined;
    this.carouselActiveFile = -1;
  }

}
